import { Fragment, useRef } from 'react'

import { Dialog, Transition } from '@headlessui/react'

import { IconClose } from '@/styles/Icon'

export interface DrawBottomProps {
  open: boolean
  children: JSX.Element[] | JSX.Element
  title?: string
  titleClassName?: string
  bodyClassName?: string
  mainClassName?: string
  onClose: () => void
  scroll?: boolean
  hideClose?: boolean
}

export function DrawBottom({
  open,
  children,
  title,
  scroll,
  hideClose = false,
  mainClassName = '',
  titleClassName = '',
  bodyClassName = '',
  onClose
}: DrawBottomProps) {
  const completeButtonRef = useRef(null)

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog initialFocus={completeButtonRef} as='div' className={`relative z-[9999]`} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bottom-0 left-0 bg-black-150 transition-opacity' />
        </Transition.Child>
        <div
          className={` ${mainClassName} pointer-events-none fixed bottom-0 left-[50%] z-50 flex h-full max-h-[60vh] w-full max-w-[440px] translate-x-[-50%] overflow-hidden rounded-tl-sm rounded-tr-sm `}
        >
          <Transition.Child
            as={Fragment}
            enter='transform transition ease-in-out duration-500'
            enterFrom='translate-y-[70%]'
            enterTo='translate-y-[0%]'
            leave='transform transition ease-in-out duration-500'
            leaveFrom='translate-y-[0%]'
            leaveTo='translate-y-[100%]'
          >
            <Dialog.Panel className='pointer-events-auto h-full w-full max-w-[440px] shadow-modal'>
              <div className={`block w-full transform overflow-hidden bg-white pb-6 align-middle shadow-modal`}>
                <div
                  className={`headerModal relative w-full px-3 pb-3 ${titleClassName} ${
                    title != '' ? 'h-[72px] pt-4' : ''
                  }`}
                >
                  {title != '' && (
                    <Dialog.Title as='h2' className={`text-titleSection`}>
                      {title}
                    </Dialog.Title>
                  )}
                  <button onClick={onClose} className={`absolute right-3 top-4 z-10 cursor-pointer`}>
                    {!hideClose && <IconClose />}
                  </button>
                </div>
                <div
                  className={`${bodyClassName} ${
                    title != '' ? 'max-h-[calc(60vh-96px)] min-h-[calc(60vh-96px)]' : 'max-h-[60vh] min-h-[60vh]'
                  } mr-1.5 h-full max-w-[calc(100%-8px)] pl-2 pr-1 ${
                    scroll ? 'scrollBarCS' : 'hiddenScrollBar overflow-y-auto'
                  }`}
                >
                  {children}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default DrawBottom
